'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = emailVerification;

var _immutable = require('immutable');

var _EmailVerificationActionTypes = require('../actionTypes/EmailVerificationActionTypes');

var _EmailVerificationActionTypes2 = _interopRequireDefault(_EmailVerificationActionTypes);

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = new _immutable.Map({
  requestState: RequestState.NOT_REQUESTED,
  verified: false,
  send: new _immutable.Map({
    requestState: RequestState.NOT_REQUESTED,
    nrSent: 0
  }),
  completeVerification: new _immutable.Map({
    requestState: RequestState.NOT_REQUESTED,
    verified: false
  })
});

function emailVerification() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _EmailVerificationActionTypes2.default.REQUEST_EMAIL_VERIFICATION:
      return state.set('requestState', RequestState.REQUESTED);
    case _EmailVerificationActionTypes2.default.SUCCEED_GET_EMAIL_VERIFICATION:
      {
        return state.merge({
          requestState: RequestState.SUCCEEDED,
          verified: payload.verified
        });
      }
    case _EmailVerificationActionTypes2.default.FAILED_GET_EMAIL_VERIFICATION:
      return state.merge({
        requestState: RequestState.FAILED
      });
    case _EmailVerificationActionTypes2.default.SEND_EMAIL_VERIFICATION:
      return state.mergeDeep({
        send: { requestState: RequestState.REQUESTED }
      });
    case _EmailVerificationActionTypes2.default.SEND_EMAIL_VERIFICATION_SENT:
      return state.mergeDeep({
        send: {
          requestState: RequestState.SUCCEEDED,
          nrSent: state.get('send').get('nrSent') + 1
        }
      });
    case _EmailVerificationActionTypes2.default.FAILED_SEND_EMAIL_VERIFICATION:
      return state.mergeDeep({
        send: { requestState: RequestState.FAILED }
      });
    case _EmailVerificationActionTypes2.default.CALL_COMPLETE_VERIFICATION:
      return state.mergeDeep({
        completeVerification: { requestState: RequestState.REQUESTED }
      });
    case _EmailVerificationActionTypes2.default.SUCCEED_COMPLETE_VERIFICATION:
      return state.mergeDeep({
        completeVerification: {
          requestState: RequestState.SUCCEEDED,
          verified: true
        }
      });
    case _EmailVerificationActionTypes2.default.FAILED_COMPLETE_VERIFICATION:
      return state.mergeDeep({
        completeVerification: { requestState: RequestState.FAILED }
      });
    default:
      return state;
  }
}
module.exports = exports['default'];